import styled, { keyframes } from 'styled-components';

export const spin = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

export const PageContainer = styled.div`
  min-height: 100vh;
  background: transparent;
  display: flex;
  flex-direction: column;
  overflow-x: hidden;
  width: 100%;
`;

export const PageContent = styled.div`
  flex: 1;
  padding: 32px 40px;
  max-width: 1200px;
  width: 100%;
  margin: 0 auto;
  box-sizing: border-box;
  overflow-x: hidden;

  @media (max-width: 768px) {
    padding: 20px;
    max-width: 100%;
  }
`;

export const PageTitle = styled.h1`
  font-size: 24px;
  font-weight: 600;
  color: ${(props) =>
    props.theme.name === 'dark' ? '#ffffff' : props.theme.colors.blueBlack};
  margin: 0 0 32px 0;

  @media (max-width: 768px) {
    font-size: 20px;
    margin-bottom: 24px;
  }
`;

// FormSection has been replaced with shared Card component
// If you need FormSection, import Card from 'components/Card' instead

export const SectionTitle = styled.h2`
  font-size: 18px;
  font-weight: 600;
  color: ${(props) =>
    props.theme.name === 'dark' ? '#ffffff' : props.theme.colors.blueBlack};
  margin-bottom: 24px;
  display: flex;
  align-items: center;
`;

// Form elements for Step2MessageComposer
export const FormGroup = styled.div`
  margin-bottom: 20px;
`;

export const Label = styled.label`
  display: block;
  font-size: 14px;
  font-weight: 500;
  color: ${(props) => (props.theme.name === 'dark' ? '#E5E7EB' : '#374151')};
  margin-bottom: 8px;

  ${(props) =>
    props.required &&
    `
    &::after {
      content: ' *';
      color: #EF4444;
    }
  `}
`;

export const Input = styled.input`
  width: 100%;
  padding: 10px 14px;
  background: ${(props) =>
    props.theme.name === 'dark' ? 'rgba(255,255,255,0.05)' : '#ffffff'};
  border: 1px solid
    ${(props) =>
      props.theme.name === 'dark' ? 'rgba(255,255,255,0.1)' : '#E5E7EB'};
  border-radius: 8px;
  color: ${(props) =>
    props.theme.name === 'dark' ? '#ffffff' : props.theme.colors.blueBlack};
  font-size: 14px;
  transition: all 0.2s;

  &:focus {
    outline: none;
    border-color: ${(props) => props.theme?.colors?.primary || '#fa4616'};
    box-shadow: 0 0 0 3px rgba(250, 70, 22, 0.1);
  }

  &::placeholder {
    color: ${(props) => (props.theme.name === 'dark' ? '#64748B' : '#9CA3AF')};
  }
`;

export const HelpText = styled.div`
  font-size: 13px;
  color: ${(props) => (props.theme.name === 'dark' ? '#64748B' : '#9CA3AF')};
  margin-top: 6px;
`;
